import {MatchmakingPriority} from '../../../../shared/matchmaking/MatchmakingEnums'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {MatchmakingPreferences, MatchmakingRequest, MatchmakingStatusUpdate} from '../../../../shared/matchmaking/MatchmakingInterfaces'
import {SocketMatchmakingSend} from '../../../shared/scripts/socket/SocketMatchmakingSend'
import {UIMatchmakingSelectMatchPopupView} from './UIMatchmakingSelectMatchPopupView'
import {UIMatchmakingSearchMatchPopupView} from './UIMatchmakingSearchMatchPopupView'
import {UIManager} from '../ui_html/UIManager'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {Scene} from '../ui_html/UISceneTypes'
import {COLONIST_VERSION} from '@colonist/types'
import {getMatchTypeEligibilityAndCreatePopup} from '../../../shared/scripts/matchmaking/MatchmakingUtilsClient'
import {socket} from '../../../shared/scripts/EntryShared'

export class UIMatchmakingFindGameController {
    private readonly searchMatchPopupView: UIMatchmakingSearchMatchPopupView
    readonly selectMatchPopupView: UIMatchmakingSelectMatchPopupView
    private readonly uiManager: UIManager
    private dontShowSelectMatchPopup: boolean = false
    private selectedMatchType: MatchmakingMatchTypes | undefined

    constructor(uiManager: UIManager) {
        this.uiManager = uiManager
        this.searchMatchPopupView = new UIMatchmakingSearchMatchPopupView()
        this.selectMatchPopupView = new UIMatchmakingSelectMatchPopupView()
    }

    init() {
        socket.controller.registerSessionEstablishedObserver(() => {
            this.resendFindGame()
        })
    }

    private resendFindGame() {
        if(!this.searchMatchPopupView.isShowing()) return

        if(!SocketMatchmakingSend.lastMatchmakingRequest) {
            this.removePopups()
            return
        }

        SocketMatchmakingSend.sendFindGame()
    }

    updateMatchmakingStatus(matchmakingStatusUpdate: MatchmakingStatusUpdate) {
        if(this.selectedMatchType == undefined) return
        this.selectMatchPopupView.hide()
        this.searchMatchPopupView.update(matchmakingStatusUpdate, this.selectedMatchType)
    }

    removePopups() {
        this.searchMatchPopupView.hide()
        this.selectMatchPopupView.hide()
    }

    loadMatchmakingState() {
        this.removePopups()
        void this.selectMatchPopupView.setRankedEligibilityAndDescription()
    }

    showMatchmakingMatchTypeSelector() {
        this.loadMatchmakingState()

        this.selectMatchPopupView.setMatchmakingOptionsHeader()
        this.dontShowSelectMatchPopup ? this.dontShowSelectMatchPopup = false : this.selectMatchPopupView.show()

        this.setRankedOptionsDisplay()
    }

    sendFindGameMessageToServer(selectedMatchType: MatchmakingMatchTypes, dontShowSelectMatchPopup: boolean = false) {
        const {isEligible, createPopup} = getMatchTypeEligibilityAndCreatePopup(selectedMatchType)
        createPopup?.()
        if(!isEligible) return

        const adblockIsActive = this.uiManager.adController.adblockState.isAdblockActive
        const matchmakingRequest: MatchmakingRequest = {
            matchPreferences: [],
            adblockEnabled: adblockIsActive,
            clientVersion: COLONIST_VERSION,
        }

        const preference: MatchmakingPreferences = {
            matchType: selectedMatchType,
            priority: MatchmakingPriority.High,
        }
        matchmakingRequest.matchPreferences.push(preference)
        this.selectedMatchType = selectedMatchType
        SocketMatchmakingSend.enterMatchmaker(matchmakingRequest)
        this.dontShowSelectMatchPopup = dontShowSelectMatchPopup
    }

    private setRankedOptionsDisplay() {
        if(this.shouldHideRankedOptions()) {
            this.hideRankedOptions()
            return
        }
        this.showRankedOptions()
    }

    private shouldHideRankedOptions(): boolean {
        const onLandingPage = this.uiManager.sceneController.scene == Scene.LandingPage
        const isUserOnMobile = UIUtilsEjsVariables.isUserOnMobile

        if(onLandingPage && !isUserOnMobile) return true

        return false
    }

    private hideRankedOptions() {
        this.selectMatchPopupView.hideRankedOptions()
    }

    private showRankedOptions() {
        this.selectMatchPopupView.showRankedOptions()
    }
}
